import React from 'react'
import { Route, Routes } from 'react-router';
import Home from '../views/Home';
import DefaultPage from "../views/DefaultPage";
import Contact from "../views/Contact";
import PortfolioView from "../views/PortfolioView";
import LocationsView from "../views/LocationsView";
import PrivacyPolicy from "../views/PrivacyPolicy";

import { paths } from '../config/paths';


const routes = (
    <Routes>
        <Route index path={paths.home} element={<Home/>} />
        <Route path={paths.portfolio} element={<PortfolioView/>} />
        <Route path={paths.locations} element={<LocationsView/>} />
        <Route path={paths.contact} element={<Contact/>} />
        <Route path={paths.privacyPolicy} element={<PrivacyPolicy/>} />
        <Route path="*" element={<DefaultPage/>} />
    </Routes>
);

export default routes;